import React from 'react';
import {
  MoreInfoTableAttrElement,
  MoreInfoTableAttrElementHeading,
  MoreInfoTableAttrElementInfo,
  MoreInfoTableContainer,
  MoreInfoTableDescription,
  MoreInfoTableHeading,
} from './MoreInfoTables.styles';

function MoreInfoTable(props) {
  const { productData } = props;

  if (!productData?.attributes) return null;

  function renderTableAttrElement(heading, attrValue) {
    return (
      <MoreInfoTableAttrElement>
        <MoreInfoTableAttrElementHeading>
          {heading}
        </MoreInfoTableAttrElementHeading>
        <MoreInfoTableAttrElementInfo>{attrValue}</MoreInfoTableAttrElementInfo>
      </MoreInfoTableAttrElement>
    );
  }
  return (
    <MoreInfoTableContainer>
      <MoreInfoTableHeading>More info</MoreInfoTableHeading>
      <MoreInfoTableDescription>
        {!!productData?.attributes?.length &&
          productData?.attributes.map(attr => {
            return (
              <React.Fragment key={`Attribute-element-${attr.name}`}>
                {renderTableAttrElement(attr?.name, attr?.value)}
              </React.Fragment>
            );
          })}
      </MoreInfoTableDescription>
    </MoreInfoTableContainer>
  );
}

export default MoreInfoTable;
